import HttpClientXml from "../utils/HttpClientXml";

// >>>All GET Api<<<

const getCities = async () => {
  let endPoint = "city";
  return HttpClientXml.get(endPoint);
};
const getBlogs = async () => {
  let endPoint = "blog-list";
  return HttpClientXml.get(endPoint);
};
const getPropertyTypes = async () => {
  let endPoint = "property-type";
  return HttpClientXml.get(endPoint);
};
const getBhks = async () => {
  let endPoint = "bhk";
  return HttpClientXml.get(endPoint);
};
const getFloors = async () => {
  let endPoint = "floor";
  return HttpClientXml.get(endPoint);
};
const getLoginProfile = async () => {
  let endPoint = "get-profile";
  return HttpClientXml.get(endPoint);
};
const getProperties = async (page = 1, limit = 1000) => {
  let endPoint = `property/?page=${page}&limit=${limit}`;
  return HttpClientXml.get(endPoint);
};
const getUsers = async () => {
  let endPoint = "user";
  return HttpClientXml.get(endPoint);
};
const getBasicUsers = async () => {
  let endPoint = "get-all-basic-user";
  return HttpClientXml.get(endPoint);
};
const getSubscriptions = async () => {
  let endPoint = "subscription";
  return HttpClientXml.get(endPoint);
};
const getAdvertisements = async () => {
  let endPoint = "advertisement";
  return HttpClientXml.get(endPoint);
};
const getFacings = async () => {
  let endPoint = "facing";
  return HttpClientXml.get(endPoint);
};
const getDesignations = async () => {
  let endPoint = "designation";
  return HttpClientXml.get(endPoint);
};
const getStaffs = async () => {
  let endPoint = "staff";
  return HttpClientXml.get(endPoint);
};
const getLocalities = async () => {
  let endPoint = "locality";
  return HttpClientXml.get(endPoint);
};
const getSociety = async () => {
  let endPoint = "society-sales";
  return HttpClientXml.get(endPoint);
};
const getCommunity = async () => {
  let endPoint = "community-sales";
  return HttpClientXml.get(endPoint);
};
const getReel = async () => {
  let endPoint = "reels";
  return HttpClientXml.get(endPoint);
};
const getInventory = async () => {
  let endPoint = "inventory-sales";
  return HttpClientXml.get(endPoint);
};
const getCommission = async () => {
  let endPoint = "commission";
  return HttpClientXml.get(endPoint);
};
const getSalary = async () => {
  let endPoint = "salary";
  return HttpClientXml.get(endPoint);
};
const getExpense = async () => {
  let endPoint = "expense";
  return HttpClientXml.get(endPoint);
};
const getMiscellenious = async () => {
  let endPoint = "miscellenious";
  return HttpClientXml.get(endPoint);
};
const getApartment = async () => {
  let endPoint = "apartment";
  return HttpClientXml.get(endPoint);
};
const getHotClients = async () => {
  let endPoint = "hot-client";
  return HttpClientXml.get(endPoint);
};
const getSalesPipeline = async () => {
  let endPoint = "leads";
  return HttpClientXml.get(endPoint);
};
const getSentEmailsToStaff = async () => {
  let endPoint = "get-staff-mail-history";
  return HttpClientXml.get(endPoint);
};
const getAdvertisementNew = async () => {
  let endPoint = "advertisement-new";
  return HttpClientXml.get(endPoint);
};
const getPropertiesWorksheet = async () => {
  let endPoint = "list-property";
  return HttpClientXml.get(endPoint);
};
const getRemarksOnProperties = async () => {
  let endPoint = "feedback";
  return HttpClientXml.get(endPoint);
};
const getDeletedProperties = async () => {
  let endPoint = "deleted-property";
  return HttpClientXml.get(endPoint);
};
const getClients = async () => {
  let endPoint = "client-detail";
  return HttpClientXml.get(endPoint);
};

// >>>All POST<<<
const addCity = async (data) => {
  let endPoint = "city";
  return HttpClientXml.post(endPoint, data);
};

const addPropertyType = async (data) => {
  let endPoint = "property-type";
  return HttpClientXml.post(endPoint, data);
};
const addBhk = async (data) => {
  let endPoint = "bhk";
  return HttpClientXml.post(endPoint, data);
};
const addFloor = async (data) => {
  let endPoint = "floor";
  return HttpClientXml.post(endPoint, data);
};
const addProperty = async (data) => {
  let endPoint = "property";
  return HttpClientXml.post(endPoint, data);
};
const addSubscription = async (data) => {
  let endPoint = "subscription";
  return HttpClientXml.post(endPoint, data);
};
const addBanner = async (data) => {
  let endPoint = "banner";
  return HttpClientXml.post(endPoint, data);
};
const addAdvertisement = async (data) => {
  let endPoint = "advertisement";
  return HttpClientXml.post(endPoint, data);
};
const addFacing = async (data) => {
  let endPoint = "facing";
  return HttpClientXml.post(endPoint, data);
};
const addDesignation = async (data) => {
  let endPoint = "designation";
  return HttpClientXml.post(endPoint, data);
};
const addStaff = async (data) => {
  let endPoint = "staff";
  return HttpClientXml.post(endPoint, data);
};
const addLocality = async (data) => {
  let endPoint = "locality";
  return HttpClientXml.post(endPoint, data);
};
const filterPropertyList = async (data) => {
  let endPoint = "filter-property";
  return HttpClientXml.post(endPoint, data);
};
const addUser = async (data) => {
  let endPoint = "user";
  return HttpClientXml.post(endPoint, data);
};
const addBasicUser = async (data) => {
  let endPoint = "basic-user-register";
  return HttpClientXml.post(endPoint, data);
};
const addSociety = async (data) => {
  let endPoint = "society-sales";
  return HttpClientXml.post(endPoint, data);
};
const addCommunity = async (data) => {
  let endPoint = "community-sales";
  return HttpClientXml.post(endPoint, data);
};
const addInventory = async (data) => {
  let endPoint = "inventory-sales";
  return HttpClientXml.post(endPoint, data);
};
const addCommission = async (data) => {
  let endPoint = "commission";
  return HttpClientXml.post(endPoint, data);
};

const addAdvertisementNew = async (data) => {
  let endPoint = "advertisement-new";
  return HttpClientXml.post(endPoint, data);
};
const addSalary = async (data) => {
  let endPoint = "salary";
  return HttpClientXml.post(endPoint, data);
};
const addExpense = async (data) => {
  let endPoint = "expense";
  return HttpClientXml.post(endPoint, data);
};
const addMiscellenious = async (data) => {
  let endPoint = "miscellenious";
  return HttpClientXml.post(endPoint, data);
};
const addApartment = async (data) => {
  let endPoint = "apartment";
  return HttpClientXml.post(endPoint, data);
};
const filterExpenseReport = async (data) => {
  let endPoint = "filter-expense-report";
  return HttpClientXml.post(endPoint, data);
};
const addSalesPipeline = async (data) => {
  let endPoint = "leads";
  return HttpClientXml.post(endPoint, data);
};
const sendMailToStaff = async (data) => {
  let endPoint = "sendMailToStaff";
  return HttpClientXml.post(endPoint, data);
};
const addPropertyWorksheetRow = async (data) => {
  let endPoint = "add-property-byOrder";
  return HttpClientXml.post(endPoint, data);
};
const deleteWorksheetProperty = async (id) => {
  let endPoint = `delete-property/${id}`;
  return HttpClientXml.post(endPoint);
};
const addBlog = async (data) => {
  let endPoint = "blog";
  return HttpClientXml.post(endPoint, data);
};
const addReel = async (data) => {
  let endPoint = "reels";
  return HttpClientXml.post(endPoint, data);
};
const addBulkProperties = async (data) => {
  let endPoint = "insert-multiple-property";
  return HttpClientXml.post(endPoint, data);
};
const deleteBulkProperties = async (data) => {
  let endPoint = "delete-multiple-property";
  return HttpClientXml.post(endPoint, data);
};
const addClientDealLocationInterest = async (data) => {
  let endPoint = "add-client-location";
  return HttpClientXml.post(endPoint, data);
};
const addClientDealMeeting = async (data) => {
  let endPoint = "add-client-meeting";
  return HttpClientXml.post(endPoint, data);
};
const addClientDealAmount = async (data) => {
  let endPoint = "add-client-deal";
  return HttpClientXml.post(endPoint, data);
};
const filterApartment = async (data) => {
  let endPoint = "filter-apartment";
  return HttpClientXml.post(endPoint, data);
};

// >>>All PUT Api<<<
const updateCity = async (id, data) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateReel = async (id, data) => {
  let endPoint = `reels/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateBlog = async (id, data) => {
  let endPoint = `blog/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatePropertyType = async (id, data) => {
  let endPoint = `property-type/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateBhk = async (id, data) => {
  let endPoint = `bhk/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateFloor = async (id, data) => {
  let endPoint = `floor/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateProperty = async (id, data) => {
  let endPoint = `property/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatePropertyStatus = async (id, data) => {
  let endPoint = `change-status-property/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateUserStatus = async (id, data) => {
  let endPoint = `user-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSubscription = async (id, data) => {
  let endPoint = `subscription/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSubscriptionStatus = async (id, data) => {
  let endPoint = `change-subscription-status/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateAdvertisementStatus = async (id, data) => {
  let endPoint = `advertisement-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateFacing = async (id, data) => {
  let endPoint = `facing/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateAdvertisement = async (data) => {
  let endPoint = `advertisement`;
  return HttpClientXml.put(endPoint, data);
};
const updateDesignation = async (id, data) => {
  let endPoint = `designation/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatStaff = async (id, data) => {
  let endPoint = `staff/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateLocality = async (id, data) => {
  let endPoint = `locality/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateUser = async (id, data) => {
  let endPoint = `user/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateBasicUser = async (id, data) => {
  let endPoint = `update-basic-user/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSociety = async (id, data) => {
  let endPoint = `society-sales/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateCommunity = async (id, data) => {
  let endPoint = `community-sales/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateInventory = async (id, data) => {
  let endPoint = `inventory-sales/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSocietyStatus = async (id, data) => {
  let endPoint = `society-sales/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateCommunityStatus = async (id, data) => {
  let endPoint = `community-sales-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateInventoryStatus = async (id, data) => {
  let endPoint = `inventory-sales-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateCommission = async (id, data) => {
  let endPoint = `commission/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSalary = async (id, data) => {
  let endPoint = `salary/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateCommissionStatus = async (id, data) => {
  let endPoint = `commission-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateSalaryStatus = async (id, data) => {
  let endPoint = `salary-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateExpense = async (id, data) => {
  let endPoint = `expense/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateExpenseStatus = async (id, data) => {
  let endPoint = `expense-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateAdvertisementNew = async (id, data) => {
  let endPoint = `advertisement-new/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateMiscellenious = async (id, data) => {
  let endPoint = `miscellenious/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateMiscelleniousStatus = async (id, data) => {
  let endPoint = `miscellenious-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateApartment = async (id, data) => {
  let endPoint = `apartment/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatSalesPipeline = async (id, data) => {
  let endPoint = `leads/${id}`;
  return HttpClientXml.put(endPoint, data);
};

// >>>All DELETE Api<<<
const deleteCity = async (id, data) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteReel = async (id, data) => {
  let endPoint = `reels/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteBlog = async (id, data) => {
  let endPoint = `blog/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deletePropertyType = async (id, data) => {
  let endPoint = `property-type/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteBhk = async (id, data) => {
  let endPoint = `bhk/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteFloor = async (id, data) => {
  let endPoint = `floor/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteProperty = async (id, data) => {
  let endPoint = `property/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteFacing = async (id, data) => {
  let endPoint = `facing/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteDesigation = async (id, data) => {
  let endPoint = `designation/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteLocality = async (id, data) => {
  let endPoint = `locality/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteUser = async (id, data) => {
  let endPoint = `user/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteBasicUser = async (id, data) => {
  let endPoint = `delete-basic-user/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteSubscription = async (id, data) => {
  let endPoint = `subscription/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteSociety = async (id, data) => {
  let endPoint = `society-sales/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteSalesPipeline = async (id, data) => {
  let endPoint = `leads/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteApartment = async (id) => {
  let endPoint = `apartment/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

/////
const addJobCategory = async (data) => {
  let endPoint = "job-category";
  return HttpClientXml.post(endPoint, data);
};
const getJobCategory = async () => {
  let endPoint = "job-category";
  return HttpClientXml.get(endPoint);
};
const updateJobCategory = async (id, data) => {
  let endPoint = `job-category/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateJobCategoryStatus = async (id, data) => {
  let endPoint = `job-category-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};

/////////////////
const addJobPost = async (data) => {
  let endPoint = "job-post";
  return HttpClientXml.post(endPoint, data);
};
const getJobPost = async () => {
  let endPoint = "job-post";
  return HttpClientXml.get(endPoint);
};
const updateJobPost = async (id, data) => {
  let endPoint = `job-post/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateJobPostStatus = async (id, data) => {
  let endPoint = `job-post-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};

////////////////
const getBanner = async () => {
  let endPoint = "banner";
  return HttpClientXml.get(endPoint);
};

const updateBannerStatus = async (id, data) => {
  let endPoint = `banner/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const updateBanner = async (id, data) => {
  let endPoint = `banner-update/${id}`;
  return HttpClientXml.put(endPoint, data);
};

//////////////
const getJobApplications = async () => {
  let endPoint = "job-application-list";
  return HttpClientXml.get(endPoint);
};

const swapProperty = async (data) => {
  let endPoint = "swap-property";
  return HttpClientXml.post(endPoint, data);
};
const readRemark = async (id) => {
  let endPoint = `feedback-read/${id}`;
  return HttpClientXml.put(endPoint);
};
/////////////////////
const getPromotion = async () => {
  let endPoint = "promotion";
  return HttpClientXml.get(endPoint);
};
const updatePromotionStatus = async (id, data) => {
  let endPoint = `promotion-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatePromotion = async (id, data) => {
  let endPoint = `promotion/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const addPromotion = async (data) => {
  let endPoint = "promotion";
  return HttpClientXml.post(endPoint, data);
};
const deletePromotion = async (id, data) => {
  let endPoint = `promotion/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteAdvertisementNew = async (id) => {
  let endPoint = `advertisement-new/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const getFilteredProperties = async (data) => {
  let endPoint = "serach-property";
  return HttpClientXml.post(endPoint, data);
};

/////////////////
const addBlogCategory = async (data) => {
  let endPoint = "blog-category";
  return HttpClientXml.post(endPoint, data);
};
const getBlogCategory = async () => {
  let endPoint = "blog-category";
  return HttpClientXml.get(endPoint);
};
const updateBlogCategory = async (id, data) => {
  let endPoint = `blog-category/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateBlogCategoryStatus = async (id, data) => {
  let endPoint = `blog-category-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const deleteBlogCategory = async (id, data) => {
  let endPoint = `blog-category/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteStaff = async (id) => {
  let endPoint = `staff/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const filterSubscription = async (data) => {
  let endPoint = "filter-subscription";
  return HttpClientXml.post(endPoint, data);
};

const getUserDownloadDocumentStatus = async () => {
  let endPoint = "get-user-access-visbility";
  return HttpClientXml.get(endPoint);
};

const getReportProperties = async () => {
  let endPoint = "complaints";
  return HttpClientXml.get(endPoint);
};

const updateUserDownloadDocumentStatus = async (data) => {
  let endPoint = `change-user-access-visbility`;
  return HttpClientXml.put(endPoint, data);
};

const deleteAdvertisement = async (id) => {
  let endPoint = `advertisement/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const deleteReportProperty = async (id) => {
  let endPoint = `complaint/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const deleteBanner = async (id) => {
  let endPoint = `banner/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const deleteJobCategory = async (id) => {
  let endPoint = `job-category/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const deleteJobVacancy = async (id) => {
  let endPoint = `job-post/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const filterLocality = async (data) => {
  let endPoint = "search-locality";
  return HttpClientXml.post(endPoint, data);
};

const updateMaxDeviceLogin = async (id, data) => {
  let endPoint = `user-device-limit/${id}`;
  return HttpClientXml.put(endPoint, data);
};

//city details
const createCityDetails = async (data) => {
  let endPoint = "city-main-viewing-info";
  return HttpClientXml.post(endPoint, data);
};

const updateCityDetails = async (id, data) => {
  let endPoint = `city-main-viewing-info/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getCityDetails = async () => {
  let endPoint = "city-main-viewing-info";
  return HttpClientXml.get(endPoint);
};

const deleteCityDetails = async (id) => {
  let endPoint = `city-main-viewing-info/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createPrimeLocationInsights = async (data) => {
  let endPoint = "prime-location-insights";
  return HttpClientXml.post(endPoint, data);
};

const updatePrimeLocationInsights = async (id, data) => {
  let endPoint = `prime-location-insights/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getGetPrimeLocationInsights = async () => {
  let endPoint = "prime-location-insights";
  return HttpClientXml.get(endPoint);
};

const deletePrimeLocationInsights = async (id) => {
  let endPoint = `prime-location-insights/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createPersonalService = async (data) => {
  let endPoint = "personal-service";
  return HttpClientXml.post(endPoint, data);
};

const updatePersonalService = async (id, data) => {
  let endPoint = `personal-service/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getPersonalService = async () => {
  let endPoint = "personal-service";
  return HttpClientXml.get(endPoint);
};

const deletePersonalService = async (id) => {
  let endPoint = `personal-service/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createWallOfFame = async (data) => {
  let endPoint = "wall-of-frame";
  return HttpClientXml.post(endPoint, data);
};

const updateWallOfFame = async (id, data) => {
  let endPoint = `wall-of-frame/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getWallOfFame = async () => {
  let endPoint = "wall-of-frame";
  return HttpClientXml.get(endPoint);
};

const deleteWallOfFame = async (id) => {
  let endPoint = `wall-of-frame/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createPeopleSaying = async (data) => {
  let endPoint = "people-saying";
  return HttpClientXml.post(endPoint, data);
};

const updatePeopleSaying = async (id, data) => {
  let endPoint = `people-saying/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getPeopleSaying = async () => {
  let endPoint = "people-saying";
  return HttpClientXml.get(endPoint);
};

const deletePeopleSaying = async (id) => {
  let endPoint = `people-saying/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createFaq = async (data) => {
  let endPoint = "faq";
  return HttpClientXml.post(endPoint, data);
};

const updateFaq = async (id, data) => {
  let endPoint = `faq/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getFaq = async () => {
  let endPoint = "faq";
  return HttpClientXml.get(endPoint);
};

const deleteFaq = async (id) => {
  let endPoint = `faq/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createAppPoster = async (data) => {
  let endPoint = "download-app-poster";
  return HttpClientXml.post(endPoint, data);
};

const updateAppPoster = async (id, data) => {
  let endPoint = `download-app-poster/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getAppPoster = async () => {
  let endPoint = "download-app-poster";
  return HttpClientXml.get(endPoint);
};

const deleteAppPoster = async (id) => {
  let endPoint = `download-app-poster/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createAdvertisementShowingOrder = async (data) => {
  let endPoint = "advertisement-showing-order";
  return HttpClientXml.post(endPoint, data);
};

const updateAdvertisementShowingOrder = async (id, data) => {
  let endPoint = `advertisement-showing-order/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getAdvertisementShowingOrder = async () => {
  let endPoint = "advertisement-showing-order";
  return HttpClientXml.get(endPoint);
};

const deleteAdvertisementShowingOrder = async (id) => {
  let endPoint = `advertisement-showing-order/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createFooterMenu = async (data) => {
  let endPoint = "footer-section";
  return HttpClientXml.post(endPoint, data);
};

const updateFooterMenu = async (id, data) => {
  let endPoint = `footer-section/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getFooterMenu = async () => {
  let endPoint = "footer-section";
  return HttpClientXml.get(endPoint);
};

const deleteFooterMenu = async (id) => {
  let endPoint = `footer-section/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const getAllDealerName = async () => {
  let endPoint = "get-all-dealer-names";
  return HttpClientXml.get(endPoint);
};

const getPropertiesByDealerName = async (data) => {
  let endPoint = "get-properties-by-dealer";
  return HttpClientXml.post(endPoint, data);
};

const createDealerSection = async (data) => {
  let endPoint = "featured-developer";
  return HttpClientXml.post(endPoint, data);
};

const updateDealerSection = async (id, data) => {
  let endPoint = `featured-developer/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getDealerSection = async () => {
  let endPoint = "featured-developer";
  return HttpClientXml.get(endPoint);
};

const deleteDealerSection = async (id) => {
  let endPoint = `featured-developer/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const createHighlightedProject = async (data) => {
  let endPoint = "top-highlighted-project";
  return HttpClientXml.post(endPoint, data);
};

const updateHighlightedProject = async (id, data) => {
  let endPoint = `top-highlighted-project/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const getHighlightedProject = async (page = 1, limit = 10) => {
  let endPoint = "top-highlighted-project";
  return HttpClientXml.get(endPoint);
};

const deleteHighlightedProject = async (id) => {
  let endPoint = `top-highlighted-project/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

const filterProperty = async (data, page = 1, limit = 1000) => {
  let endPoint = `filter-property-admin?page=${page}&limit=${limit}`;
  return HttpClientXml.post(endPoint, data);
};

const getPropertyById = async (id) => {
  let endPoint = `get-property-by-id/${id}`;
  return HttpClientXml.get(endPoint);
};

const deleteRemarks = async (id) => {
  let endPoint = `feedback/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export default {
  updateBanner,
  deleteRemarks,
  getPropertyById,
  filterProperty,
  deleteHighlightedProject,
  getHighlightedProject,
  updateHighlightedProject,
  createHighlightedProject,
  getPropertiesByDealerName,
  getAllDealerName,
  deleteDealerSection,
  getDealerSection,
  updateDealerSection,
  createDealerSection,
  deleteFooterMenu,
  getFooterMenu,
  updateFooterMenu,
  createFooterMenu,
  deleteAdvertisementShowingOrder,
  getAdvertisementShowingOrder,
  updateAdvertisementShowingOrder,
  createAdvertisementShowingOrder,
  deleteAppPoster,
  getAppPoster,
  updateAppPoster,
  createAppPoster,
  deleteFaq,
  getFaq,
  updateFaq,
  createFaq,
  deletePeopleSaying,
  getPeopleSaying,
  updatePeopleSaying,
  createPeopleSaying,
  deleteWallOfFame,
  getWallOfFame,
  updateWallOfFame,
  createWallOfFame,
  deletePersonalService,
  getPersonalService,
  updatePersonalService,
  createPersonalService,
  deletePrimeLocationInsights,
  getGetPrimeLocationInsights,
  updatePrimeLocationInsights,
  createPrimeLocationInsights,
  deleteCityDetails,
  getCityDetails,
  updateCityDetails,
  createCityDetails,
  updateMaxDeviceLogin,
  filterLocality,
  deleteJobVacancy,
  deleteJobCategory,
  addAdvertisementNew,
  deleteBanner,
  deleteAdvertisement,
  updateUserDownloadDocumentStatus,
  getUserDownloadDocumentStatus,
  deleteAdvertisementNew,
  filterSubscription,
  deleteStaff,
  filterApartment,
  addBlogCategory,
  getBlogCategory,
  updateBlogCategory,
  deleteReportProperty,
  updateBlogCategoryStatus,
  deleteBlogCategory,
  getFilteredProperties,
  deletePromotion,
  addPromotion,
  updatePromotion,
  updatePromotionStatus,
  getPromotion,
  updateAdvertisementNew,
  readRemark,
  swapProperty,
  getJobApplications,

  getBanner,
  updateBannerStatus,

  addJobPost,
  getJobPost,
  updateJobPost,
  updateJobPostStatus,

  addJobCategory,
  getJobCategory,
  updateJobCategory,
  updateJobCategoryStatus,
  // >>>GET<<<
  getCities,
  getReportProperties,
  getBlogs,
  getPropertyTypes,
  getBhks,
  getFloors,
  getLoginProfile,
  getAdvertisementNew,
  getProperties,
  getUsers,
  getSubscriptions,
  getAdvertisements,
  getFacings,
  getDesignations,
  getStaffs,
  getLocalities,
  getSociety,
  getCommunity,
  getInventory,
  getCommission,
  getSalary,
  getExpense,
  getMiscellenious,
  getApartment,
  getHotClients,
  getSalesPipeline,
  getSentEmailsToStaff,
  getPropertiesWorksheet,
  getRemarksOnProperties,
  getDeletedProperties,
  getClients,
  getReel,
  // >>>POST<<<
  addCity,
  addBlog,
  addPropertyType,
  addBhk,
  addFloor,
  addProperty,
  addSubscription,
  addBanner,
  addAdvertisement,
  addFacing,
  addReel,
  addDesignation,
  addStaff,
  addLocality,
  filterPropertyList,
  addUser,
  addBasicUser,
  addSociety,
  addCommunity,
  addInventory,
  addCommission,
  addSalary,
  addExpense,
  addMiscellenious,
  addApartment,
  filterExpenseReport,
  addSalesPipeline,
  sendMailToStaff,
  addPropertyWorksheetRow,
  deleteWorksheetProperty,
  addBulkProperties,
  addClientDealLocationInterest,
  addClientDealMeeting,
  addClientDealAmount,
  // >>>PUT<<<
  updateBlog,
  updateCity,
  updatePropertyType,
  updateBhk,
  updateFloor,
  updateProperty,
  updatePropertyStatus,
  updateUserStatus,
  updateSubscription,
  updateSubscriptionStatus,
  updateReel,
  updateAdvertisementStatus,
  updateAdvertisement,
  updateFacing,
  updateDesignation,
  updatStaff,
  updateLocality,
  updateUser,
  updateBasicUser,
  updateSociety,
  updateCommunity,
  updateInventory,
  updateSocietyStatus,
  updateCommunityStatus,
  updateInventoryStatus,
  updateCommission,
  updateSalary,
  updateCommissionStatus,
  updateSalaryStatus,
  updateExpense,
  updateExpenseStatus,
  updateMiscellenious,
  updateMiscelleniousStatus,
  updateApartment,
  updatSalesPipeline,

  // >>>DELETE<<<
  deleteCity,
  deleteReel,
  deleteBlog,
  deletePropertyType,
  deleteBhk,
  deleteFloor,
  deleteProperty,
  deleteFacing,
  deleteDesigation,
  deleteLocality,
  deleteUser,
  deleteBasicUser,
  getBasicUsers,
  deleteSubscription,
  deleteSociety,
  deleteSalesPipeline,
  deleteBulkProperties,
  deleteApartment,
};
